import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { AssetsFormValues } from "src/models/Assets.model";
import AssetsForm from "../Layouts/AssetsForm";
import {
  useEditAssetsMutation,
  useGetAssetsByIdQuery,
} from "src/services/AssetsServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedId: string;
};

const EditAssetsFormWrapper = ({ onClose, selectedId }: Props) => {
  const [assetsData, setAssetsData] = useState<any>({});
  const [editAsset] = useEditAssetsMutation();
  const { data, isFetching, isLoading } = useGetAssetsByIdQuery(selectedId);

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setAssetsData(data?.data);
    }
  }, [data, isLoading, isFetching]);
  // Form Initial Values
  const initialValues: AssetsFormValues = {
    assetName:assetsData?.assetName,
    bill:assetsData?.bill,
  };

  // Validation Schema
  const validationSchema = object().shape({
    assetName: string().required("Please enter name"),
  });

  // Handle Submit
  const handleSubmit = (
    values: AssetsFormValues,
    { setSubmitting, resetForm }: FormikHelpers<AssetsFormValues>
  ) => {
    editAsset({
        body : values ,
        id: selectedId
    }).then((res: any) => {
        if (res?.error) {
          showToast("error", res?.error?.data?.message);
        } else {
          if (res?.data?.status) {
            showToast("success", res?.data?.message);
              resetForm();
              onClose();
          } else {
            showToast("error", res?.data?.message);
          }
        }
        setSubmitting(false);
      });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik 
      enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {isLoading && isFetching && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <AssetsForm formikProps={formikProps} onClose={onClose} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditAssetsFormWrapper;
